import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function useEmployees() {
  const [emps, setEmps] = useState([]);
  useEffect(() => { api.get("/employees").then((r) => setEmps(r.data)).catch(() => setEmps([])); }, []);
  return emps;
}

export function EmployeePicker({ value, onChange, employees, testid }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testid}><SelectValue placeholder="Choose employee…" /></SelectTrigger>
      <SelectContent className="max-h-72">
        {employees.map((e) => (
          <SelectItem key={e.id} value={e.id}>{e.first_name} {e.last_name}{e.department ? ` · ${e.department}` : ""}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export const today = () => new Date().toISOString().slice(0, 10);
export const inDays = (n) => new Date(Date.now() + n * 864e5).toISOString().slice(0, 10);
